module.exports = __webpack_public_path__ + "img/unit7.60aee697.jpg";